/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
// mui
import { Stack, TextField, Autocomplete, Checkbox, Chip } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
// auth
import { ACCESSABLE_VALUE } from '../../auth/utils';
// --------------------------------------------------------------------------------------------------------

CustomAutoComplete.propTypes = {
    loading: PropTypes.bool,
    orignalArray: PropTypes.array,
    optionData: PropTypes.array,
    handleOnChange: PropTypes.func,
    label: PropTypes.string,
    ValueExrp: PropTypes.string,
    DisplayExrp: PropTypes.string,
    setEmptyData: PropTypes.func,
    hasAccess: PropTypes.string,
    open: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    heightD: PropTypes.string,
};
// --------------------------------------------------------------------------------------------------------

export default function CustomAutoComplete({ loading, ValueExrp, DisplayExrp, setEmptyData, optionData,
    label, orignalArray, handleOnChange, open, onOpen, onClose, hasAccess, heightD }) {

    //  get logged In  User Details

    /* const blurHandler = (event) => {
        if (orignalArray.length === 0) {
            console.log(setEmptyData, "setEmptyData")
            setEmptyData(['ALL']);
        }
    }   */

    // Update open state based on selection
    // const inputRef = useRef();

    /* useEffect(() => {
        if (!orignalArray || orignalArray.length === 0) {
            // Auto-focus to open dropdown if selection is empty
            const timeout = setTimeout(() => {
                inputRef?.current?.focus();
            }, 100); // slight delay to allow render
            return () => clearTimeout(timeout);
        }
    }, [orignalArray]); */

    return (
        <>
            <ClickAwayListener onClickAway={onClose}>
                <div>
                    <Autocomplete
                        className={hasAccess !== ACCESSABLE_VALUE ? '' : 'ExtendedGridFilters'}
                        multiple
                        disableCloseOnSelect
                        fullWidth
                        size="small"
                        disabled={hasAccess !== ACCESSABLE_VALUE}
                        options={optionData}
                        getOptionLabel={(option) => option[ValueExrp]}
                        value={
                            orignalArray?.includes('ALL')
                                ? ['ALL']
                                : optionData?.filter((option) =>
                                    orignalArray?.includes(option[ValueExrp])
                                )
                        }
                        onChange={handleOnChange}
                        open={open}
                        onOpen={onOpen}
                        onClose={onClose} // keep this so Esc / select triggers it
                        renderOption={(props, option, { selected }) => {
                            const isChecked =
                                orignalArray?.includes('ALL') ||
                                optionData.length - 1 === orignalArray?.length ||
                                orignalArray?.includes(option[ValueExrp]);

                            return (
                                <li {...props} style={{ fontSize: '0.6rem', padding: '3px', margin: '2px 0' }}>
                                    <Checkbox className="RequestDropDownCheckBoxStyle" checked={isChecked} />
                                    {typeof option === 'string' ? option : option[ValueExrp]}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                label={label}
                                className="RequestDropDownTextFieldStyle"
                                {...params}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                    style: { fontSize: '0.8rem', height: '32px' },
                                }}
                                sx={{ height: heightD || '32px' }}
                            //  sx={{ "& .MuiInputBase-root": { maxHeight: "40px", minWidth: "120px", maxWidth: "120px" }, }}
                            />
                        )}
                        renderTags={(value, getTagProps) => (
                            <Stack direction="row" alignItems="center" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                {value.includes('ALL') ? (
                                    <Chip
                                        key="ALL"
                                        size="small"
                                        label="All"
                                        className="RequestDropDownChipStyle"
                                        {...getTagProps({ index: 0 })}
                                    />
                                ) : (
                                    value.slice(0, 1).map((option, index) => (
                                        <Chip
                                            key={index}
                                            size="small"
                                            label={option[ValueExrp]?.substring(0, 5)}
                                            title={option[ValueExrp]}
                                            className="RequestDropDownChipStyle"
                                            {...getTagProps({ index })}
                                        />
                                    ))
                                )}
                                {value.length > 1 && (
                                    <Chip
                                        size="small"
                                        label={`+${value.length - 1}`}
                                        title={`+${value.length - 1} more`}
                                        className="RequestDropDownChipStyle"
                                    />
                                )}
                            </Stack>
                        )}
                    />
                </div>
            </ClickAwayListener>
        </>
    );
}

